import React, { type ReactNode } from "react";
import { Flex, Box } from "@chakra-ui/react";

export function Container({ children }: { children: ReactNode }) {
  return (
    <Flex
      bg="white"
      border="1px"
      borderColor="brand.border.extraLight"
      borderLeftRadius="6px"
      borderRight="none"
      color="brand.textSecondary.light"
      direction="column"
      gap={{ base: "smallest", xl: "smaller" }}
      textStyle="caption2"
      fontSize={{ base: "brand.2xs", lg: "brand.xs" }}
      pos="relative"
      py="small"
      pl={{ base: "small", xl: "big" }}
      w="100%"
      overflow="hidden"
    >
      <Box bg="product.teal.300" pos="absolute" inset="-1px" right="auto" w={{ base: "smaller", xl: "small" }} />
      {children}
    </Flex>
  );
}
